import type { Level } from '../core/hp/types';
import { cultureName, language, t } from '../i18n/I18n';
import { isRoofLevel, MAX_LEVELS } from './roofRooms';

const FLOOR_KEYS = ['#Floor0', '#Floor1', '#Floor2', '#Floor3', '#Floor4', '#Floor5', '#Floor6'] as const;
// The app drops the number 4 for these regions (BuildingController.GetLevelTitle).
const NO_FOUR = new Set(['hk', 'my', 'sg', 'tw', 'cn']);

/** BuildingController.GetLevelTitle: a floor by its place over the ground, 0 the lowest floor above it. */
function levelTitle(aboveGround: number): string {
  const lang = language(), country = (cultureName().split('-')[1] ?? '').toLowerCase();
  let key = aboveGround + 1;
  if (lang === 'en' && country !== 'us' && country !== 'ca') key--;
  if (key >= 4 && NO_FOUR.has(country)) key++;
  if (key < 0) return t('#LowerLevel', String(-key));
  return t(FLOOR_KEYS[Math.min(key, FLOOR_KEYS.length - 1)]);
}

/**
 * How the level at `index` is named in the interface: its own name, else the app's title for its place
 * (BuildingController.GetLevelAutoTitle): «Крыша» for the roof floor and for a sixth floor over the ground, else the
 * floor's number counted from the lowest one that is not a basement (`Level.lowerLevel`, the app's `IsLowerLevel`).
 */
export function levelLabel(levels: readonly Level[], index: number): string {
  const level = levels[index];
  if (!level) return '';
  if (level.name.trim()) return level.name.trim();
  if (isRoofLevel(level)) return t('#RoofLevelTitle');
  const ground = levels.findIndex(each => !each.lowerLevel), above = index - (ground < 0 ? levels.length : ground);
  return above >= MAX_LEVELS ? t('#RoofLevelTitle') : levelTitle(above);
}
